<script setup lang="ts">
import { BottoPagePanel } from '@botto/core';

defineProps<{
  title: string;
}>();
</script>

<template>
  <BottoPagePanel :title="title" standalone>
    <template v-if="$slots.actions" #actions>
      <slot name="actions" />
    </template>
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>

    <div class="tracker-list">
      <p v-if="$slots.hint" class="tracker-list__hint">
        <slot name="hint" />
      </p>
      <div v-if="$slots.toolbar" class="tracker-list__toolbar">
        <slot name="toolbar" />
      </div>
      <div class="tracker-list__body">
        <slot />
      </div>
    </div>
    <slot name="overlays" />
  </BottoPagePanel>
</template>

<style scoped>
.tracker-list {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  gap: 12px;
}

.tracker-list__hint {
  flex: 0 0 auto;
  margin: 0;
  font-size: 0.875rem;
  color: var(--dx-color-text-secondary, #666);
}

.tracker-list__toolbar {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.tracker-list__body {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.tracker-list__body > :deep(.dx-datagrid),
.tracker-list__body > :deep(.dx-tabpanel) {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
}
</style>
